export const actionTypes = {
  SET_PLAYING_VOICE_ID: 'SET_PLAYING_VOICE_ID',
  SET_CURRENT_PLAYING_VOICE_ITEM_VARIANT:
    'SET_CURRENT_PLAYING_VOICE_ITEM_VARIANT',
  SET_CURRENT_PLAYING_VOICE_SECTION: 'SET_CURRENT_PLAYING_VOICE_SECTION',
};

export const setPlayingVoiceId = (voiceId) => ({
  type: actionTypes.SET_PLAYING_VOICE_ID,
  voiceId,
});

export const setCurrentPlayingVoiceItemVariant = (variant) => ({
  type: actionTypes.SET_CURRENT_PLAYING_VOICE_ITEM_VARIANT,
  variant,
});

export const setCurrentPlayingVoiceSection = (section) => ({
  type: actionTypes.SET_CURRENT_PLAYING_VOICE_SECTION,
  section,
});
